(() => {
  const storageKey = 'finewine:smooth-scroll-customer-reviews';
  let smoothScrollRequested = false;

  try {
    smoothScrollRequested = sessionStorage.getItem(storageKey) === 'true';
    sessionStorage.removeItem(storageKey);
  } catch (error) {
    return;
  }

  if (!smoothScrollRequested) return;

  const scrollToReviews = (attempt = 0) => {
    const reviews = document.getElementById('judgeme_product_reviews');
    if (!reviews) {
      if (attempt < 50) window.setTimeout(() => scrollToReviews(attempt + 1), 100);
      return;
    }

    const destination = `${window.location.pathname}${window.location.search}#judgeme_product_reviews`;
    window.history.replaceState(window.history.state, '', destination);
    reviews.scrollIntoView({
      behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
      block: 'start'
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => scrollToReviews(), { once: true });
  } else {
    scrollToReviews();
  }
})();
